import { defineStore } from "pinia";
import { privateBoaHttp, publicBoaHttp } from "@/boa-api-client";
import fixedEncodeURIComponent from "@/util/fixed-encode-uri-component";
import { HTTPError } from "ky";
import type { Ticket } from "best-of-awards-api";
import type { User } from "best-of-awards-api";

export type Contact = {
  GSI1_PK: string;
  GSI1_SK: string;
  GSI2_PK: string;
  GSI2_SK: string;
  PK: string;
  SK: string;
  id: string;
  firstName: string;
  lastName: string;
  mobile: string;
  emailAddress: string;
  emailOptIn: boolean;
  smsOptIn: boolean;
  title?: string;
  user?: User;
  tickets: Array<Ticket>;
};

type State = any;

export default defineStore("contacts", {
  state: (): State => ({}),
  getters: {},
  actions: {
    async getContact(contactPK: string) {
      try {
        const response: { success: boolean; contact: Contact } =
          await privateBoaHttp
            .get(`contacts?PK=${fixedEncodeURIComponent(contactPK)}`)
            .json();
        if (response.success) {
          return response.contact;
        }
        return null;
      } catch (error) {
        console.error((error as any).message);
      }
    },
    // async signupContact(contact: Contact) {
    //   try {
    //     const { userCreated } = (await publicBoaHttp
    //       .put("signup-contact", { json: contact })
    //       .json()) as any;
    //     return { success: true, userCreated };
    //   } catch (error) {
    //     const { message } = await (error as any).response.json();
    //     return { success: false, message };
    //   }
    // },
    async unsubscribe(
      email: string
    ): Promise<{ success: boolean; message?: string }> {
      try {
        if (email) {
          const { success }: { success: boolean } = await publicBoaHttp
            .get(`unsubscribe/${email}`)
            .json();
          return { success };
        }
        return { success: true };
      } catch (error) {
        if (error instanceof HTTPError) {
          const { message = "Unknown error" } = await error.response.json();
          return { success: false, message };
        }
        return { success: false, message: "Unknown error" };
      }
    },
    clear() {
      this.$reset();
    },
  },
});
